import { render, staticRenderFns } from "./WmsProducts.vue?vue&type=template&id=6bbb07ae&scoped=true"
import script from "./WmsProducts.vue?vue&type=script&lang=js"
export * from "./WmsProducts.vue?vue&type=script&lang=js"
import style0 from "./WmsProducts.vue?vue&type=style&index=0&id=6bbb07ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb07ae",
  null
  
)

export default component.exports